import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";

export default function DispenseTable({
  dispenseData,
  selectedDispense,
  onSelect,
}: any) {
  return (
    <Box>
      <Table size="medium" sx={{ minWidth: "auto" }}>
        <Box sx={{ p: 2, display: "flex", width: "100%", mb: 4 }}>
          <Box
            sx={{
              borderRadius: "15px",
              boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
              maxHeight: "200px",
              width: "100%",
              overflowY: "auto",
              overflowX: "auto",
            }}>
            <Table sx={{ minWidth: "auto" }}>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Type</TableCell>
                  <TableCell align="center">Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dispenseData?.dispenses?.map((dispense: any) => (
                  <TableRow
                    key={dispense.id}
                    hover
                    onClick={() => onSelect(dispense)}
                    sx={{
                      cursor: "pointer",
                      backgroundColor:
                        selectedDispense?.id === dispense.id
                          ? "rgba(0,0,0,0.1)"
                          : "transparent",
                    }}>
                    <TableCell align="center">
                      {dispense.specType || "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {new Date(dispense.createdDate).toLocaleDateString(
                        "en-GB"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </Table>
    </Box>
  );
}
